import { Component, Prop, Vue, VModel } from 'vue-property-decorator';
import { LETTER_A_IN_ASCII_CODE, ALPHABET_LETTER_NUMBERS } from '@/constants';

@Component
export default class MapDataInput extends Vue {
  @Prop() display: string;
  @Prop() placeholder: string;
  @VModel() model: string;

  get itemSelectColumns(): string[] {
    return [...Array(ALPHABET_LETTER_NUMBERS)].map((_, letterInASCII) =>
      String.fromCharCode(letterInASCII + LETTER_A_IN_ASCII_CODE)
    );
  }
}
